<template>
  <section class="reports-kpi-section" :style="gridStyle">
    <SalesKpiCard
      v-for="metric in normalizedCards"
      :key="metric.title"
      :title="metric.title"
      :value="metric.value"
      :value-meta="metric.valueMeta"
      :value-meta-lines="metric.valueMetaLines"
      :value-meta-items="metric.valueMetaItems"
      :extra-values="metric.extraValues"
      :value-segments="metric.valueSegments"
      :value-scale="metric.valueScale"
      :truncate-value="metric.truncateValue"
      :icon="metric.icon"
      :icon-bg="metric.iconBg"
      :icon-color="metric.iconColor"
    />
  </section>
</template>

<script>
import SalesKpiCard from '@/components/sales/SalesKpiCard.vue';

export default {
  name: 'ReportsKpiSection',
  components: {
    SalesKpiCard,
  },
  props: {
    cards: {
      type: Array,
      default: () => [],
    },
    desktopColumns: {
      type: Number,
      default: 4,
    },
    laptopColumns: {
      type: Number,
      default: null,
    },
    tabletColumns: {
      type: Number,
      default: 2,
    },
  },
  computed: {
    normalizedCards() {
      return (Array.isArray(this.cards) ? this.cards : []).filter((card) => {
        return card && typeof card === 'object' && String(card.title || '').trim() !== '';
      });
    },
    gridStyle() {
      const desktop = Math.max(1, Number(this.desktopColumns || 4));
      const laptop = Math.max(1, Number(this.laptopColumns || desktop));
      const tablet = Math.max(1, Number(this.tabletColumns || 2));

      return {
        '--reports-kpi-columns-desktop': String(desktop),
        '--reports-kpi-columns-laptop': String(laptop),
        '--reports-kpi-columns-tablet': String(tablet),
      };
    },
  },
};
</script>
